<div class="main-app">
  <router-outlet></router-outlet>
</div>
@if (isProjectTablePage) {
  <a target="_blank" href="https://beaconcure.com" class="footnote" (click)="registerMatomoEvent()">
    <img src="../assets/images/beaconcure-icon-grey.svg" class="beaconcure-icon" />
    Powered by Beaconcure
  </a>
}
